import { gql } from '@grandvisionhq/graphql';

// Variable id needs to be there. If not callback onCompleted from useMutation is not successful.
const UPDATE_PERSONAL_DETAILS = gql`
  mutation updatePersonalDetails($customerId: ID!, $input: PersonalDetailsB2CUpdateInput!) {
    updateB2CPersonalDetails(customerId: $customerId, input: $input) {
      id
      preferredStore {
        globalStoreId
      }
    }
  }
`;

export { UPDATE_PERSONAL_DETAILS };
//# sourceMappingURL=update-personal-details.js.map
